/* eslint-disable camelcase */
import axios from 'axios'
import Qs from 'qs' // eslint-disable-line import/no-extraneous-dependencies

const ROOT = process.env.REACT_APP_AUGMENTT_API_URL

export function getTableData({ apiUrl, page, page_size, sort_field, sort_direction, filters, onlyIds }) {
  return axios.get(`${ROOT}${apiUrl}`, {
    params: {
      page,
      page_size,
      sort_field,
      sort_direction,
      onlyIds,
      ...filters,
    },
    paramsSerializer: {
      serialize: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
    },
  })
}

export function getEngageData({
  apiUrl,
  integrationApplicationId,
  requiredModules,
  organizationId,
  page,
  page_size,
  sort_field,
  sort_direction,
  filters,
  ignoredEmployees,
  license,
  select,
}) {
  return axios.get(`${ROOT}${apiUrl}`, {
    params: {
      page,
      page_size,
      sort_field,
      sort_direction,
      integrationName: integrationApplicationId,
      requiredModules,
      organizationId,
      license: license !== undefined ? license : true, // Default to true for backward compatibility
      ignored: 0,
      autoIgnored: 0,
      ignoredEmployees,
      select,
      ...filters,
    },
    paramsSerializer: {
      serialize: (params) => Qs.stringify(params, { arrayFormat: 'repeat' }),
    },
  })
}
